import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Stack } from '@mui/material';
import { getPartnerRole } from '../services/user/getPartnerRole';
import { PATH_DASHBOARD } from './paths';

export default function PartnerRoleGuard({ allowedRoles, fallbackPath, children }) {
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    const validateRole = async () => {
      try {
        const currentPartner = JSON.parse(localStorage.getItem('currentPartner') || 'null');
        if (!currentPartner?._id) {
          setAllowed(false);
          return;
        }
        const roleResponse = await getPartnerRole(currentPartner._id);
        const currentRole = roleResponse?.role || null;
        setAllowed(allowedRoles.includes(currentRole));
      } catch (error) {
        setAllowed(false);
      }
    };
    validateRole();
  }, [allowedRoles]);

  if (allowed === null) {
    return (
      <Stack sx={{ width: '100%', height: '100vh' }} justifyContent="center" alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (!allowed) {
    return <Navigate to={fallbackPath || PATH_DASHBOARD.organizations.root} replace />;
  }

  return children;
}

PartnerRoleGuard.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  fallbackPath: PropTypes.string,
  children: PropTypes.node.isRequired,
};
